import { render, staticRenderFns } from "./ganganjieshao.vue?vue&type=template&id=136d70a0&scoped=true&"
import script from "./ganganjieshao.vue?vue&type=script&lang=js&"
export * from "./ganganjieshao.vue?vue&type=script&lang=js&"
import style0 from "./ganganjieshao.vue?vue&type=style&index=0&id=136d70a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136d70a0",
  null
  
)

export default component.exports